<template>
    <app-dialog
        :value="value"
        size="lg"
        @close="$emit('close')"
        @input="$emit('input', $event)"
    >
        <template #header>
            <div
                class="flex flex-col lg:flex-row items-center gap-2"
                :class="marginTop ? 'mt-2' : ''"
            >
                <span :class="textSize">
                    Selecciona la referencia del producto
                    <span class="text-theme-primary">
                        {{ productName }}
                    </span>
                </span>
                <div v-if="showConfirmButton">
                    <app-button @click="$emit('confirm')">
                        ✔️ Confirmar
                    </app-button>
                </div>
            </div>
        </template>
        <div>
            <div
                class="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full p-2"
            >
                <div
                    v-for="(item, index) in references"
                    :key="item.id"
                    class="w-full"
                >
                    <button
                        class="relative w-full h-full flex flex-col p-4 text-left transition-all duration-200 border rounded-xl hover:shadow-md active:scale-95 focus:outline-none"
                        :class="
                            referenceSelected === index
                                ? 'border-stack-emphasis bg-primary/5 ring-2 ring-stack-emphasis'
                                : 'border-theme-border bg-theme-canvas hover:border-primary/50'
                        "
                        @click="$emit('select', index)"
                    >
                        <div
                            v-if="referenceSelected === index"
                            class="absolute top-2 right-2 text-theme-success"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </div>

                        <div class="mb-2">
                            <span
                                class="text-xs font-semibold uppercase tracking-wider text-theme-success"
                            >
                                Variante
                            </span>
                            <p
                                class="text-sm font-bold text-theme-primary capitalize"
                            >
                                T {{ item.size }}
                                <span class="text-theme-base mx-1">|</span>
                                {{ item.color }}
                            </p>
                        </div>

                        <div
                            class="mt-auto border-t border-theme-border w-full"
                        >
                            <span class="text-xs text-theme-base">
                                Precio
                            </span>
                            <p class="text-lg font-black text-theme-primary">
                                {{ item.priceOffer | money }}
                            </p>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </app-dialog>
</template>

<script>
import AppDialog from "@/components/utils/AppDialog.vue";

export default {
    name: "ProductReferenceModal",
    components: { AppDialog },
    props: {
        value: {
            type: Boolean,
            required: true
        },
        productName: {
            type: String,
            required: true
        },
        references: {
            type: Array,
            required: true
        },
        referenceSelected: {
            type: Number,
            default: null
        },
        textSize: {
            type: String,
            default: "text-lg"
        },
        showConfirmButton: {
            type: Boolean,
            default: false
        },
        marginTop: {
            type: Boolean,
            default: true
        }
    }
};
</script>
